import React from 'react'
import { ReactComponent as MatchIcon } from '../../../../assets/images/cross-client-match.svg'
import { ReactComponent as NoMatchIcon } from '../../../../assets/images/cross-client-no-match.svg'
import { ReactComponent as PartialMatchIcon } from '../../../../assets/images/cross-client-partial-match.svg'
import { ReactComponent as UnableToMatchIcon } from '../../../../assets/images/cross-client-unable-to-match.svg'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

interface CrossClientResultsOverviewProps {
  fullMatchResults: number
  partialMatchResults: number
  notMatchingResults: number
  unableToMatchResults: number
}

export const CrossClientResultsOverview: React.FC<CrossClientResultsOverviewProps> = ({
  fullMatchResults,
  partialMatchResults,
  notMatchingResults,
  unableToMatchResults,
}) => {
  return (
    <>
      <h6>Results overview</h6>
      <div className='d-flex flex-column gap-2'>
        <div className='d-flex gap-2 align-items-center'>
          <MatchIcon width={12} height={12} />
          <span>
            <span className='medium'>{fullMatchResults} </span>
            full matches
          </span>
        </div>
        <div className='d-flex gap-2 align-items-center'>
          <PartialMatchIcon width={12} height={12} />
          <span>
            <span className='medium'>{partialMatchResults} </span>
            partial matches
          </span>
        </div>
        <div className='d-flex gap-2 align-items-center'>
          <NoMatchIcon width={12} height={12} />
          <span>
            <span className='medium'>{notMatchingResults} </span>
            didn't match
          </span>
        </div>
        <div className='d-flex gap-2 align-items-center'>
          <UnableToMatchIcon />
          <span>
            <span className='medium'>{unableToMatchResults} </span>
            incomplete data
            <Tooltip className='position-fixed' title="These clients couldn't be evaluated due to missing data, or incomplete records.">
              <i className='bi bi-info-square fs-6 zocks-text-gray-700 ps-1' />
            </Tooltip>
          </span>
        </div>
      </div>
    </>
  )
}
